import { useTranslation } from 'react-i18next'

import { RadioGroupModal } from '../../Radio'

import { QA_NAME_YES_NO_MODAL } from './TaskFormYesNoConfirmationModal.constants'
import { getOptions } from './TaskFormYesNoConfirmationModal.utils'

function TaskFormYesNoConfirmationModal({ name, ...restProps }) {
  const { t } = useTranslation()

  return (
    <RadioGroupModal
      {...restProps}
      formFieldsProps={{
        getOptions,
        name,
        title: t('Task.FormYesNoConfirmationModalTextKey'),
      }}
      qaName={QA_NAME_YES_NO_MODAL}
      title={t('Task.FormYesNoConfirmationModalTitleKey')}
    />
  )
}

export default TaskFormYesNoConfirmationModal
